import { createGlobalStyle, css } from 'styled-components';
import Reset from '@yoweb/ui/styles/reset';
import { th } from '@yoweb/ui/styles/utils/theme';
import { jsx as _jsx } from "react/jsx-runtime";
export var globalStyleBase = css(["", ";html{font-size:16px;color:", ";font-family:", ";}body{font-size:", ";}a{color:inherit;text-decoration:none;}button{color:inherit;}html,body,#__next{height:100%;}.no-scroll,.no-scroll-flyout{overflow:hidden;}"], Reset, th.getColor('charcoal'), th.getFontFamily('primary'), th.getFontSize('bodyLg'));
export var GlobalStyle = createGlobalStyle(["", ";"], globalStyleBase);

var GlobalStyles = function GlobalStyles() {
  return /*#__PURE__*/_jsx(GlobalStyle, {});
};

export default GlobalStyles;